import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import ConnectDevice from '../pages/ConnectDevice';
import Machines from '../pages/Machines/Machines';
import VersaBuilt from '../pages/VersaBuilt';
import MachineCycleTime from '../pages/MachineCycleTime';
import FastlaneOrders from '../pages/Orders';
import AddMaterialOrder from '../pages/Material/AddMaterialOrder';
import MaterialOrders from '../pages/Material/MaterialOrders';
import MaterialOrderDetails from '../pages/Material/MaterialOrderDetails';
import OrderDetails from '../pages/Orders/OrderDetails';
import AddOrder from '../pages/Orders/AddOrder';
import AddInternalOrder from '../pages/Orders/AddInternalOrder';
import MachineStatuses from '../pages/MachineStatuses';
import Machine from '../pages/Machines/Machine';
import OrderLineItemDetails from '../pages/Orders/OrderLineItemDetails';
import MaterialRequests from '../pages/Material/MaterialRequest';
import ShopFloorMaterialNeeds from '../pages/Material/ShopFloorMaterialNeeds';
import OrderLineItems from '../pages/Orders/OrderLineItems';
import QualityGages from '../pages/QualityGages';
import TravelerAudit from '../pages/TravelerAudit';
import KeyenceValidationReport from '../pages/KeyenceValidationReport';
import RobotProgramAudit from '../pages/Audit/RobotPrograms';
import { ListMaterialReceiving } from '../pages/Material';
import ProductionQueues from '../pages/ProductionQueues';
import ProductionQuestionsListPage from '../pages/Production/ProductionQuestions';
import KittingTimes from '../pages/KittingTimes';
import VendorMaterials from '../pages/Material/VendorMaterials';
import MultiGripWorkholding from '../pages/Workholding/MultiGrip';
import MaterialInventory from '../pages/Material/MaterialInventory';
import MaterialReservations from '../pages/Material/MaterialReservations';
import MaterialCertificates from '../pages/MaterialCertificates';
import Ballooning from '../pages/Ballooning';
import BallooningProjects from '../pages/BallooningProjects';
import CamProgrammingGridView from '../pages/CamProgramming/GridView';
import InspectionResultsEntryPage from '../pages/InspectionResultsInput';
import Dashboard from '../pages/Dashboard';
import LedgerExports from '../pages/Admin/LedgerExports';
import { MaterialLengthsPage } from '../components/MaterialLengths';
import AdminRoutes from '../pages/Admin/routes';
import KitStagingAdminRoutes from '../pages/KitStaging/AdminRoutes';
import RequireGroup from './RequireGroup';

// Scheduling pages
import SchedulingDashboard from '../pages/Scheduling/Dashboard';
import SchedulingJobs from '../pages/Scheduling/Jobs';
import SchedulingJobDetail from '../pages/Scheduling/Jobs/JobDetail';
import SchedulingExceptions from '../pages/Scheduling/Exceptions';
import SchedulingQueues from '../pages/Scheduling/Queues';
import SchedulingJobSchedule from '../pages/Scheduling/Capacity/JobSchedule';
import SchedulingCapacity from '../pages/Scheduling/Capacity';
import SchedulingTasks from '../pages/Scheduling/Tasks';
import SchedulingStaff from '../pages/Scheduling/Staff';
import SchedulingStaffDetail from '../pages/Scheduling/Staff/StaffDetail';
import SchedulingStaffOverview from '../pages/Scheduling/Staff/StaffWeeklyOverview';
import SchedulingMachines from '../pages/Scheduling/Machines';
import SchedulingMachineDetail from '../pages/Scheduling/Machines/MachineDetail';
import SchedulingCalendars from '../pages/Scheduling/Configuration/Calendars';
import SchedulingSchedulerConfig from '../pages/Scheduling/Configuration/SchedulerConfig';
import SchedulingHeadroom from '../pages/Scheduling/Capacity/Analytics';
import SchedulingRoles from '../pages/Scheduling/Settings/Roles';
import SchedulingAuditLog from '../pages/Scheduling/Settings/AuditLogPage';
import SchedulingApiDocs from '../pages/Scheduling/ApiDocs';

const PrivateRoutes = () => {
	return (
		<div className="container max-w-full min-h-full w-full">
			<Routes>
				<Route path="/dash" element={<Dashboard />} />
				<Route path="/" element={<Navigate to="orders/line-items" />} />
				<Route path="connect" element={<ConnectDevice />} />
				<Route path="orders" element={<FastlaneOrders />} />
				<Route path="orders/add" element={<AddOrder />} />
				<Route path="orders/internal/add" element={<AddInternalOrder />} />
				<Route path="orders/:id" element={<OrderDetails />} />
				<Route path="orders/line-items" element={<OrderLineItems />} />
				<Route
					path="orders/line-items/:id"
					element={<OrderLineItemDetails />}
				/>
				<Route path="program-scoring" element={<CamProgrammingGridView />} />
				<Route
					path="cam-programming/*"
					element={<Navigate to="/program-scoring" replace />}
				/>
				<Route path="production/queues" element={<ProductionQueues />} />
				<Route
					path="production/production-questions"
					element={<ProductionQuestionsListPage />}
				/>
				<Route path="production/kitting-times" element={<RequireGroup group="Shop Managers"><KittingTimes /></RequireGroup>} />
				<Route path="material/materials" element={<MaterialInventory />} />
				<Route path="material/lengths" element={<MaterialLengthsPage />} />
				<Route
					path="material/material-reservations"
					element={<MaterialReservations />}
				/>
				<Route path="material/orders" element={<MaterialOrders />} />
				<Route path="material/orders/add" element={<AddMaterialOrder />} />
				<Route path="material/orders/add/:id" element={<AddMaterialOrder />} />
				<Route path="material/orders/:id" element={<MaterialOrderDetails />} />
				<Route path="material/requests" element={<MaterialRequests />} />
				<Route
					path="material/shop-floor-requests"
					element={<ShopFloorMaterialNeeds />}
				/>
				<Route path="material/receiving" element={<ListMaterialReceiving />} />
				<Route path="material/vendor-materials" element={<VendorMaterials />} />
				<Route
					path="material/certificates"
					element={<MaterialCertificates />}
				/>
				<Route path="ballooning" element={<BallooningProjects />} />
				<Route path="ballooning/:id" element={<Ballooning />} />
				<Route
					path="inspection/:id/results-entry"
					element={<InspectionResultsEntryPage />}
				/>
				<Route path="machines" element={<Machines />} />
				<Route path="machines/:id" element={<Machine />} />
				<Route path="machines/statuses" element={<MachineStatuses />} />
				<Route
					path="workholding/multigrip"
					element={<MultiGripWorkholding />}
				/>
				<Route
					path="versabuilt/mill-automation-systems"
					element={<VersaBuilt />}
				/>
				<Route path="cycle-time" element={<MachineCycleTime />} />
				<Route path="quality-gages" element={<QualityGages />} />
				<Route path="quality-gages" element={<QualityGages />} />
				<Route path="quality-gages/:id" element={<QualityGages />} />
				<Route path="quality/traveler-audit" element={<TravelerAudit />} />
				<Route
					path="quality/keyence-validation-audit"
					element={<Navigate to="/quality/keyence-validation-report" replace />}
				/>
				<Route
					path="quality/keyence-validation-report"
					element={<KeyenceValidationReport />}
				/>
				<Route path="audit/robot-programs" element={<RobotProgramAudit />} />
				{/* Scheduling */}
				<Route path="scheduling/dashboard" element={<SchedulingDashboard />} />
				<Route path="scheduling/jobs" element={<SchedulingJobs />} />
				<Route path="scheduling/jobs/:id" element={<SchedulingJobDetail />} />
				<Route path="scheduling/exceptions" element={<SchedulingExceptions />} />
				<Route path="scheduling/queues" element={<SchedulingQueues />} />
				<Route path="scheduling/job-schedule" element={<SchedulingJobSchedule />} />
				<Route path="scheduling/capacity" element={<SchedulingCapacity />} />
				<Route path="scheduling/headroom" element={<SchedulingHeadroom />} />
				<Route path="scheduling/tasks" element={<SchedulingTasks />} />
				<Route path="scheduling/staff" element={<SchedulingStaff />} />
				<Route path="scheduling/staff/:id" element={<SchedulingStaffDetail />} />
				<Route path="scheduling/staff-overview" element={<SchedulingStaffOverview />} />
				<Route path="scheduling/machines" element={<SchedulingMachines />} />
				<Route path="scheduling/machines/:id" element={<SchedulingMachineDetail />} />
				<Route path="scheduling/calendars" element={<SchedulingCalendars />} />
				<Route path="scheduling/scheduler" element={<SchedulingSchedulerConfig />} />
				<Route path="scheduling/roles" element={<SchedulingRoles />} />
				<Route path="scheduling/audit-log" element={<SchedulingAuditLog />} />
				<Route path="scheduling/api-docs" element={<SchedulingApiDocs />} />

				<Route path="admin/ledger-exports" element={<RequireGroup group="Shop Managers"><LedgerExports /></RequireGroup>} />
				<Route path="/admin/kit-staging/*" element={<RequireGroup group="Shop Managers"><KitStagingAdminRoutes /></RequireGroup>} />
				<Route path="/admin/*" element={<AdminRoutes />} />
			</Routes>

		</div>
	);
};

export default PrivateRoutes;
